import { Text } from '@change/ds-core-ui/Text';
import { EditOutlineIcon } from '@change/ds-icons/EditOutlineIcon';

import { TranslateHtml, useI18n } from '@change-corgi/core-react/i18n';

import { VideoConsentCheckbox } from '#src/app/pages/socialStarter/shared/components';
import { useTrackPageView } from '#src/app/pages/socialStarter/shared/hooks';
import {
	ClaimAction,
	DecisionMakerSection,
	Loading,
	CtaSection,
	VoiceHeardSection,
} from '#src/app/shared/components/socialStarter';

import { SocialPostPreview } from '../components/SocialPostPreview';

import { useSocialStarterLayout } from './hooks/useSocialStarterLayout';

export const Layout: React.FC = () => {
	const { translate } = useI18n();
	useTrackPageView();
	const {
		data: {
			draft,
			authorName,
			authorHandle,
			authorAvatarUrl,
			platform,
			videoCoverUrl,
			caption,
			heading,
			subheading,
			loading,
			videoConsentCheckboxEnabled,
			videoConsent,
		},
		actions: { claimFromTop, claimFromBottom, setVideoConsent },
	} = useSocialStarterLayout();

	if (loading) return <Loading qaId="social-starter-loading" />;

	return (
		<div className="flex flex-col" data-qa="social-starter">
			<div className="from-fill-information-weaker to-background-base bg-linear-to-b pt-8 md:pt-20">
				<div className="container mx-auto flex max-w-150 flex-col items-center gap-4 px-4 md:gap-10 md:px-0">
					<header className="flex max-w-xl flex-col items-center gap-3 text-center" data-qa="social-starter-header">
						<Text as="h1" variant="heading" size="medium">
							{heading}
						</Text>
						<Text as="p" size="large" className="text-typography-weak max-w-sm">
							{subheading}
						</Text>
					</header>

					<div className="flex w-full flex-col items-center gap-6">
						<SocialPostPreview
							title={draft.ask}
							authorName={authorName}
							authorHandle={authorHandle}
							authorAvatarUrl={authorAvatarUrl}
							thumbnailUrl={videoCoverUrl}
							thumbnailAlt={
								platform
									? translate('corgi.social_starter.preview.thumbnail_alt.with_platform', { platform })
									: translate('corgi.social_starter.preview.thumbnail_alt.generic')
							}
							platform={platform}
							caption={caption}
						/>
						{videoConsentCheckboxEnabled && (
							<VideoConsentCheckbox
								isSelected={videoConsent}
								onChange={setVideoConsent}
								className="mx-auto mb-4 w-full max-w-md md:max-w-xl"
							/>
						)}
						<ClaimAction onClick={claimFromTop} buttonText={translate('corgi.social_starter.claim.button_label')} />
					</div>
				</div>
			</div>

			<VoiceHeardSection />
			<DecisionMakerSection />

			<div className="mt-20">
				<CtaSection
					icon={<EditOutlineIcon />}
					onCtaClick={claimFromBottom}
					headingText={<TranslateHtml value="corgi.start_a_petition.chat_app_entry.cta_heading" />}
					buttonText={translate('corgi.social_starter.claim.button_label')}
					qaId="social-starter-footer-cta-button"
				/>
			</div>
		</div>
	);
};
